/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HandlingUnitType = {
    Skid: 'Skid',
    Pallet: 'Pallet',
    Bin: 'Bin',
    Box: 'Box',
    Bundle: 'Bundle',
    Cage: 'Cage',
    Crate: 'Crate',
    Drum: 'Drum',
    Reel: 'Reel',
    Roll: 'Roll',
    Loose: 'Loose',
    Other: 'Other'
} as const;
export type HandlingUnitType = typeof HandlingUnitType[keyof typeof HandlingUnitType];


export function instanceOfHandlingUnitType(value: any): boolean {
    for (const key in HandlingUnitType) {
        if (Object.prototype.hasOwnProperty.call(HandlingUnitType, key)) {
            if (HandlingUnitType[key as keyof typeof HandlingUnitType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HandlingUnitTypeFromJSON(json: any): HandlingUnitType {
    return HandlingUnitTypeFromJSONTyped(json, false);
}

export function HandlingUnitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HandlingUnitType {
    return json as HandlingUnitType;
}

export function HandlingUnitTypeToJSON(value?: HandlingUnitType | null): any {
    return value as any;
}

export function HandlingUnitTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): HandlingUnitType {
    return value as HandlingUnitType;
}

